import { TableHeader } from '../shared/types';

const getSortedFieldGroups = (headers: TableHeader[]): any => {
  const expandedFieldGroups = [
    [
      { label: 'This week to date', key: 'performance_this_week_to_date' },
      { label: 'Change', key: 'performance_wow_in_progress' },
    ],
    [
      { label: 'Last week to date', key: 'performance_last_week_to_date' },
      { label: 'Last full week', key: 'performance_last_week' },
      { label: 'Change', key: 'performance_wow_last_completed' },
      { label: '2 Weeks ago', key: 'performance_last_last_week' },
    ],
    [{ label: 'Release to date', key: 'performance_rtd' }],
  ];

  return expandedFieldGroups.map((group: any) => {
    return group.filter((field: any) =>
      headers.some((header: any) => header.key === field.key)
    );
  });
};

export default getSortedFieldGroups;
